"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function regionParser(region) {
    if (region.includes("+")) {
        return region.slice(region.indexOf("+") + 1, region.length);
    }
    return region;
}
exports.default = regionParser;
